// extracted by mini-css-extract-plugin
module.exports = {"movieList":"MovieList_movieList__2Kax7","movieImg":"MovieList_movieImg__2abXL","movieTitle":"MovieList_movieTitle__2KZ43"};